import { useState } from 'react';

import { useAuth } from 'context/AuthProvider/AuthProvider';
import { useSnackbar } from 'context/SnackbarProvider/SnackbarProvider';
import { getAuthHeader } from 'utils/auth/getAuthHeader';
import { fetchData, FetchDataResponse } from 'utils/fetchData';

const useFetchWithToken = () => {
  const [isDataLoading, setIsDataLoading] = useState(false);
  const { setSnackbarInfo } = useSnackbar();
  const { getAccessToken } = useAuth();

  const fetchDataWithToken = async <T>(url: string, handleData: (data: T) => void) => {
    const token = await getAccessToken();
    if (token) {
      try {
        setIsDataLoading(true);
        const result = (await fetchData(url, getAuthHeader(token))) as FetchDataResponse<T>;

        if (result.data) {
          setIsDataLoading(false);
          handleData(result.data);
        } else if (result.errorResponse) {
          // eslint-disable-next-line
          console.error(`Failed to retrieve data: ${result.errorResponse.message}`);
          setSnackbarInfo({
            severity: 'error',
            open: true,
            content: {
              header: 'Failed to retrieve data',
              message: 'If the issue persists please report it to our support team',
            },
          });
        }
      } catch (err) {
        const error = err as Error;
        setSnackbarInfo({
          severity: 'error',
          open: true,
          content: {
            header: 'Failed to retrieve data',
            message: error.message,
          },
        });
        setIsDataLoading(false);
      }
    }
  };

  return { fetchDataWithToken, isDataLoading };
};

export default useFetchWithToken;
